import { Avatar as MantineAvatar, AvatarProps as MantineAvatarProps, MantineSize } from "@mantine/core";
import React from "react";
import { subscribeProfilePictureSasUrl } from "./profilePictureSas";

type AvatarProps = Omit<MantineAvatarProps, "src"> & {
  id?: string | null;
  name: string;
  size?: MantineSize | (string & {}) | number;
};

const Avatar: React.FC<AvatarProps> = ({ id, name, size = "md", ...props }) => {
  const [src, setSrc] = React.useState<string | undefined>();

  React.useEffect(() => {
    setSrc(undefined);

    if (!id) return;

    return subscribeProfilePictureSasUrl(id, setSrc);
  }, [id]);

  return <MantineAvatar src={src} name={name} size={size} {...props} />;
};

export default Avatar;
